import React, { useContext, useState, useEffect } from "react";
import { Box, Flex, Skeleton } from "@chakra-ui/react";
import { OrdersContext } from "../Context/OrdersContext";
import SalesBulkAction from "./SalesBulkAction";
import OrdersFilters from "./OrdersFilters";
import { useParams } from "react-router-dom";
import { arrayToOption } from "../../Utils/formatUtils";

const OrdersListMenu = () => {
  const { selectedOrders, getAllStatus } = useContext(OrdersContext);
  const [statusOptions, setStatusOptions] = useState([]);
  const [isLoadingStatus, setIsLoadingStatus] = useState(true);
  const [filters, setFilters] = useState({ statusId: null, name: "" });

  let params = useParams().state;

  const fetchStatus = async () => {
    setStatusOptions(arrayToOption(await getAllStatus()));
    setIsLoadingStatus(false);
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  useEffect(() => {
    statusOptions.length > 0 &&
      setFilters({ ...filters, statusId: getUrlStatus() });
  }, [useParams(), statusOptions]);

  const getUrlStatus = () => {
    let status;
    switch (params) {
      case "creados":
        status = statusOptions.filter((status) => status.value == 1);
        break;
      case "pendientes":
        status = statusOptions.filter(
          (status) =>
            status.value === 3 || status.value === 4 || status.value === 2
        );
        break;
      case "entregas":
        status = statusOptions.filter((status) => status.value === 5);
        break;
      case "finalizados":
        status = statusOptions.filter(
          (status) => status.value === 6 || status.value === 7
        );
        break;
      default:
        status = statusOptions;
    }
    return status;
  };

  return (
    <>
      {selectedOrders.length > 0 ? (
        <SalesBulkAction></SalesBulkAction>
      ) : isLoadingStatus ? (
        <Box>
          <Box w={["auto", "10%"]}>
            <Skeleton height="1.5rem" mb="3rem" />
          </Box>

          <Flex
            align="left"
            flexDirection={["column", "row"]}
            justifyContent="space-around"
            margin="1rem 0"
          >
            <Box w={["auto", "40%"]}>
              <Skeleton height="2rem" />
            </Box>
            <Box w={["auto", "40%"]}>
              <Skeleton height="2rem" />
            </Box>
            <Box align="center" pb={"1rem"}>
              <Skeleton height="2rem" w={"6rem"} />
            </Box>
          </Flex>
          <Box>
            <Skeleton height="2rem" />
          </Box>
        </Box>
      ) : (
        <OrdersFilters
          filters={filters}
          statusOptions={statusOptions}
          setFilters={setFilters}
        ></OrdersFilters>
      )}
    </>
  );
};

export default OrdersListMenu;
